import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { EnumAcaoRecurso } from 'src/app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from 'src/app/models/enum/recurso-perfil.enum';
import { FiltroModel } from 'src/app/models/filtro.model';
import { IOsaFiltroModel } from 'src/app/models/osa-filtro-model';
import { IOsaModel } from 'src/app/models/osa-model';
import { IPermissaoModel } from 'src/app/models/permissao.model';
import { AuthService } from 'src/app/services/auth.service';
import { OsaService } from 'src/app/services/osa.service';
import Swal from 'sweetalert2';
import {
  ModalConfirmarInativacaoComponent
} from "../../../shared/components/modal-confirmar-inativacao/modal-confirmar-inativacao.component";
import { BaseListComponent } from "../../../shared/components/base-list/base-list.component";
import { element } from "protractor";

@Component({
  selector: 'app-osa-list',
  templateUrl: './osa-list.component.html',
  styleUrls: ['./osa-list.component.scss']
})
export class OsaListComponent extends BaseListComponent implements OnInit, AfterViewInit {
  public dataSource = new MatTableDataSource<any>([])
  public selectedModel: any;
  public semDados = false;
  public filtro: IOsaFiltroModel = {} as IOsaFiltroModel;
  public pageEvent: any;
  public totalItens: number;
  public numeroOsa: number;
  public isHabilitaReativar: boolean;
  public displayedColumn: string[] = ['id', 'numeroOsa', 'numeroOpa', 'ug', 'statusUg', 'origemAuditoria', 'tipoAuditoria', 'coordenacao', 'dataInicio', 'dataFim', 'status', 'situacao'];
  public situacaoSelecionada: number = 2;
  public permissoes: IPermissaoModel;

  // NOVO: Propriedade para armazenar os filtros aplicados
  private filtrosAtivos: IOsaFiltroModel = {} as IOsaFiltroModel;

  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild('tabela1') public tabela1: MatSort;

  constructor(
    private osaService: OsaService,
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setarPermissoes();

    // NOVO: Escutar mudanças de filtros do componente de filtro
    this.osaService.filtrosAplicados$.subscribe(filtros => {
      if (filtros) {
        this.filtrosAtivos = { ...filtros };
        this.aplicarFiltros();
      }
    });
  }

  private setarPermissoes(): void {
    this.permissoes = new IPermissaoModel();
    this.permissoes.consultar = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.Consultar);
    this.permissoes.elaborar = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.Elaborar);
    this.permissoes.editar = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.Editar);
    this.permissoes.imprimir = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.Imprimir);
    this.permissoes.inativarReativar = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.AtivarInativar);
    this.permissoes.enviarParaAprovacao = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.EnviarParaAprovacao);
    this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.Visualizar);
    this.permissoes.gerarNovaVersao = this.authService.possuiPermissao(EnumRecursoPerfil.ManterOSA, EnumAcaoRecurso.GerarNovaVersao);
  }

  ngAfterViewInit() {
    this.configurarFiltro()
    this.obter();
  }

  private aplicarFiltros(): void {
    const numeroOsaAtual = this.numeroOsa;

    this.filtro = { ...this.filtrosAtivos };
    this.filtro.pagina = 1;

    if (numeroOsaAtual) {
      this.filtro.numeroOsa = numeroOsaAtual;
    }

    this.obter();
  }

  public visualizar(id: number) {
    this.router.navigate([`/osa/${id}/visualizar`]);
  }

  public elaborar(id: number) {
    this.router.navigate([`/osa/${id}/elaborar`]);
  }

  public inativar(id: number): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = 'modal-component';
    dialogConfig.width = '650px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { titulo: 'Tem certeza que deseja inativar essa OSA?' };
    const modal = this.matDialog.open(
      ModalConfirmarInativacaoComponent,
      dialogConfig
    );

    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.osaService
          .inativar(id, data)
          .then((res) => {
            if (res.sucesso) {
              this.exibirMensagemSucesso('OSA inativada com sucesso.');
            } else {
              this.exibirMensagemAlerta(res.mensagem.descricao);
            }
          })
          .catch((err) => {
            this.exibirMensagemErro(err.mensagem.descricao);
          })
          .finally(() => {
            this.obter();
          });
      }
    });
  }

  public novaVersao(id: number) {
    this.router.navigate([`/osa/${id}/nova-versao`]);
  }

  public reativar(id: number) {
    Swal.fire({
      title: "Reativar Registro",
      text: "Tem certeza que deseja reativar esse registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.osaService
          .reativar(id)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: 'success',
                text: res.mensagem.descricao,
              });
              this.obter()
            } else {
              {
                Swal.fire({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  icon: 'warning',
                  text: res.mensagem.descricao,
                });
              }
            }
          })
          .catch((err) => {
            {
              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: 'error',
                text: err.mensagem.descricao,
              });
            }
          })
      }
    })
  }

  public filtrarPorNumero() {
    this.selectedModel = null;

    if (!this.numeroOsa || this.numeroOsa.toString().trim() === '') {
      this.numeroOsa = null;
    }

    if (this.filtrosAtivos && Object.keys(this.filtrosAtivos).length > 0) {
      this.filtro = { ...this.filtrosAtivos };
    } else {
      this.filtro = {} as IOsaFiltroModel;
      this.filtro.ativo = this.situacaoSelecionada === 2 ? true : this.situacaoSelecionada === 3 ? false : null;
    }

    this.filtro.numeroOsa = this.numeroOsa;
    this.filtro.pagina = 1;
    this.filtro.itensPorPagina = this.paginator ? this.paginator.pageSize : 15;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.obter();
  }



  public obter(): void {
    this.selectedModel = null;

    if ((!this.filtrosAtivos || Object.keys(this.filtrosAtivos).length === 0) && !this.numeroOsa) {
      this.configurarFiltro();
    }

    this.osaService.obter(this.filtro).then(() => {
      this.osaService.currentOsa.subscribe(res => {


        if (res.resultado && res.resultado.length > 0) {

          this.dataSource = new MatTableDataSource<any>(res.resultado);
          this.semDados = false;
        } else {
          this.dataSource = new MatTableDataSource<IOsaModel>([]);
          this.semDados = true;
        }

        this.dataSource._updateChangeSubscription();
        this.totalItens = res.totalItens || 0;

        this.dataSource.sortingDataAccessor = (item: IOsaModel, property) => {
          switch (property) {
            case 'ano': return item?.ano;
            case 'numeroOsa': return item?.numero;
            case 'numeroOpa': return item?.planejamento?.opa?.numero;
            case 'origemAuditoria': return item?.planejamento?.opa?.origem?.descricao;
            case 'ug': return item?.unidadeGestora?.sigla || item?.planejamento?.opa?.unidadeGestora?.sigla;
            case 'tipoAuditoria': return item?.planejamento?.opa?.tipoAuditoria?.nome;
            case 'statusUg': return item?.statusUg;
            case 'coordenacao': return item?.planejamento?.opa?.auditorCoordenacao?.coordenacao?.sigla;
            case 'dataInicio': return item?.dataInicioRealizacao || item?.planejamento?.opa?.dataInicioPrevista;
            case 'dataFim': return item?.dataFimRealizacao || item?.planejamento?.opa?.dataFimPrevista;
            case 'status': return item?.status?.nome;
            case 'situacao': return item?.ativo;
            default: return item[property];
          }
        };


        if (this.tabela1) {
          this.dataSource.sort = this.tabela1;
        }
      });
    });
  }


  pageChanged(e) {
    if (!this.filtro) {
      this.filtro = {} as IOsaFiltroModel;
    }

    this.filtro.pagina = e.pageIndex + 1;
    this.filtro.itensPorPagina = e.pageSize;

    const temFiltroNumero = this.numeroOsa && this.numeroOsa.toString().trim() !== '';
    const temFiltrosAvancados = this.filtrosAtivos && Object.keys(this.filtrosAtivos).length > 0;

    if (temFiltrosAvancados) {
      const { pagina, itensPorPagina } = this.filtro;
      this.filtro = {
        ...this.filtrosAtivos,
        pagina,
        itensPorPagina
      };
    }

    if (temFiltroNumero) {
      this.filtro.numeroOsa = this.numeroOsa;
    }

    if (!temFiltrosAvancados && !temFiltroNumero) {
      this.filtro.ativo = this.situacaoSelecionada === 2 ? true : this.situacaoSelecionada === 3 ? false : null;
    }

    this.obter();
  }

  sortData(sort) {
    if (!this.filtro) {
      this.filtro = {} as IOsaFiltroModel;
    }

    const mapeamentoColunas = {
      'numeroOsa': 'numero',
      'numeroOpa': 'planejamento.opa.numero',
      'ug': 'unidadeGestora.sigla',
      'statusUg': 'statusUg',
      'origemAuditoria': 'planejamento.opa.origem.descricao',
      'tipoAuditoria': 'planejamento.opa.tipoAuditoria.nome',
      'coordenacao': 'planejamento.opa.auditorCoordenacao.coordenacao.sigla',
      'dataInicio': 'dataInicioRealizacao',
      'dataFim': 'dataFimRealizacao',
      'status': 'status.nome',
      'situacao': 'ativo'
    };

    const colunaBackend = mapeamentoColunas[sort.active] || sort.active;

    this.filtro.colunaOrder = colunaBackend;
    this.filtro.direcao = sort.direction;
    this.filtro.pagina = 1;
    this.filtro.itensPorPagina = this.paginator ? this.paginator.pageSize : 15;

    if (this.paginator && this.paginator.pageIndex !== 0) {
      setTimeout(() => {
        this.paginator.pageIndex = 0;
      }, 0);
    }

    const temFiltroNumero = this.numeroOsa && this.numeroOsa.toString().trim() !== '';
    const temFiltrosAvancados = this.filtrosAtivos && Object.keys(this.filtrosAtivos).length > 0;

    if (temFiltrosAvancados) {
      const { pagina, itensPorPagina, colunaOrder, direcao } = this.filtro;
      this.filtro = {
        ...this.filtrosAtivos,
        pagina,
        itensPorPagina,
        colunaOrder,
        direcao
      };
    }

    if (temFiltroNumero) {
      this.filtro.numeroOsa = this.numeroOsa;
    }

    if (!temFiltrosAvancados && !temFiltroNumero) {
      this.filtro.ativo = this.situacaoSelecionada === 2 ? true : this.situacaoSelecionada === 3 ? false : null;
    }

    this.obter();
  }

  private configurarFiltro() {
    const situacao = this.situacaoSelecionada ?? 2;
    this.filtro.ativo = situacao === 2 ? true : situacao === 3 ? false : null;

    if (this.paginator) {
      this.filtro.pagina = this.paginator.pageIndex + 1;
      this.filtro.itensPorPagina = this.paginator.pageSize;
    }
  }



  public selecionar(item: any) {

    const anoCorrente = new Date().getFullYear();

    const anoItem = new Date(item.dataInicioRealizacao).getFullYear();

    this.isHabilitaReativar = !(anoItem < anoCorrente && item.ativo === false);

    item.selecionado = !item.selecionado;

    if (item.selecionado) {
      if (this.modelsSelected().length === 1) {
        this.selectedModel = item;
      } else if (this.modelsSelected().length > 1) {
        this.selectedModel = null;
      }
    } else {
      if (this.selectedModel === item) {
        this.selectedModel = null;
      }

      const remainingSelected = this.modelsSelected();
      if (remainingSelected.length === 1) {
        this.selectedModel = remainingSelected[0];
      }
    }
  }

  public modelsSelected(): Array<any> {
    let retorno = this.dataSource.data.filter(x => x.selecionado === true);
    return retorno;
  }

  public imprimir(id: number) {
    this.router.navigateByUrl(`osa/${id}/imprimir`)
  }

  public relatorioConsolidado() {
    const ids = this.modelsSelected().map(osa => osa.id).toString();
    this.router.navigate([`/osa/${ids}/relatorio-consolidado`]);
  }

  public botaoImpressaoColetivaHidden(): boolean {
    return !this.permissoes.imprimir || this.modelsSelected().length <= 1;
  }
}
